// single product page where the user configures a product

import { mapGetters, mapActions, mapMutations } from 'vuex'
import { halfNHalfItem } from '../../utils/const'

import slug from 'slug'

export default {
  data () {
    return {
      showPrice: true
    }
  },
  computed: {
    ...mapGetters(['currentItem', 'activeProduct', 'configItemPrice', 'configItemTotalPrice', 'activeChild', 'products', 'currentStore', 'cart']),
  },
  mounted () {
    if (this.$route.params && this.$route.params.pathMatch) { // in web enforce the correct url for product customization page
      if (((this.currentItem && slug(this.currentItem.name) !== this.$route.params.pathMatch) || !this.currentItem)
      && this.$route.params.pathMatch !== 'halfnhalf' && this.$route.params.pathMatch !== 'loyalty') {
        try {
          const product = Object.values(this.products).map(group => group.items).flat().filter(item => slug(item.name) === this.$route.params.pathMatch)[0]
          if (product && ['pizza', 'deal'].includes(product.product_type)) {
            this.clearCurrentItem()
            this.setCurrentItem({
              product: Object.assign(product, {
                selectedSize: product.sizes[0],
                products: false,
                cartIndex: null,
                qty: 1
              })
            })
            this.$router.push({ path: '/menu/' + (product.product_type === 'deal' ? 'deal' : 'product') + '/' + slug(product.name) })
          } else {
            this.$router.push({ path: '/menu/' + product.product_type })
          }
        } catch (e) {
          this.$router.push({ path: '/' })
        }
      }
      if (this.$route.params.pathMatch === 'halfnhalf' && this.currentItem === null) {
        this.setCurrentItem({ product: JSON.parse(JSON.stringify(halfNHalfItem)) })
      }
      if (this.$route.params.pathMatch === 'halfnhalf' && this.currentItem.product_type !== 'halfNHalf') {
        this.clearCurrentItem()
        this.setCurrentItem({ product: JSON.parse(JSON.stringify(halfNHalfItem)) })
        this.$router.push({ path: '/menu/product/halfnhalf' })
      }
    }

    if (this.$platform !== 'web' && !this.currentStore) {
      this.redirectToHome()
    }
  },
  methods: {
    ...mapActions(['addToCart', 'setCurrentItem', 'resetConfigItemPrice']),
    ...mapMutations(['removeActiveChild', 'clearCurrentItem']),
    async productSaved (e) {
      if (this.$platform === 'pos') {
        let newItem = true
        if (this.currentItem.cartIndex !== null && this.currentItem.cartIndex !== undefined) {
          newItem = false
        }
        const cartIndex = await this.addToCart(this.currentItem)
        if (newItem) {
          this.setCurrentItem(Object.assign(this.currentItem, { cartIndex }))
          this.$root.$emit('scrollCartToBottom')
        }
      } else {
        if (this.activeChild.length === 0) { // we are done editing the root product as no layer is selected
          if (typeof this.triggerFlyingCircle === 'function') {
            this.triggerFlyingCircle(e.target)
            setTimeout(() => {
              this.redirectAfterCustomization()
              this.addToCart(this.currentItem) // add root item to cart
            }, 1000)
          } else {
            this.addToCart(this.currentItem)
            this.redirectAfterCustomization()
          }
        } else { // it is not root item
          this.removeActiveChild() // we are done editing the child product
        }
      }
    }
  }
}